//import Modal from "./modules/Modal"

//const modal = new Modal();

// function openModal(el) {
//   const modal = document.getElementById(el);
//   if (modal) {
//     modal.style.display = "flex"; 
//     modal.outerHTML.classList.add= "show"; // Use 'flex' to center the modal
//   } else {
//     console.error("Modal element not found");
//   }
// }

// function closeModal(el) {
//   const modal = document.getElementById(el);
//   if (modal) {
//     modal.style.display = "none";
//   } else {
//     console.error("Modal element not found");
//   }
// }


// function saveChanges() {
//   closeModal();
// }

// window.onclick = function (event) {
//   const modal = document.getElementById("modalSopExitIntent");
//   if (modal ) {
//     modal.style.display = "none";
//   }
// };

// document.addEventListener("keydown", function (event) {
//   const modal = document.getElementById("modalSopExitIntent");
//   if (modal && event.key === "Escape") {
//     modal.style.display = "none";
//   }
// });


  document.addEventListener("DOMContentLoaded", function () {
    // Tab Navigation Logic
    const navLinks = document.querySelectorAll(".nav-tabs .nav-link");
    const tabPanes = document.querySelectorAll(".tab-pane");
  
    navLinks.forEach((link) => {
      link.addEventListener("click", function (event) {
        event.preventDefault();
  
        // Remove active class from all nav links and panes
        navLinks.forEach((nav) => nav.classList.remove("active"));
        tabPanes.forEach((pane) => pane.classList.remove("active", "show"));
  
        // Add active class to the clicked link and corresponding pane
        link.classList.add("active");
        const targetId = link.getAttribute("href").substring(1);
        const targetPane = document.getElementById(targetId);
        if (targetPane) {
          targetPane.classList.add("active", "show");
        }
      });
    });
  
    // Currency Toggle Button Logic
    const toggleButtons = document.querySelectorAll(".tri-state-toggle-button");
  
    toggleButtons.forEach((button) => {
      button.addEventListener("click", function () {
        // Remove active class from all toggle buttons
        toggleButtons.forEach((btn) => btn.classList.remove("active"));
  
        // Add active class to the clicked button
        button.classList.add("active");
      });
    });

    window.successStoriesSwiper = null;
    window.successHeroStoriesSwiper = null;
    window.initSuccessStoriesSlider = function () {
      if (window.successStoriesSwiper) {
          window.successStoriesSwiper.destroy(true, true);
      }
       
    }
    window.initSuccessHeroStoriesSlider = function () {
      if (window.successHeroStoriesSwiper) {
          window.successHeroStoriesSwiper.destroy(true, true);
      }
       
    }
  });
  
jQuery(document).ready(function() {
    jQuery('.faq__header').click(function() {
        const faq = jQuery(this).parent();
        const currentlyActiveFaq = jQuery('.faq.active');

        if (currentlyActiveFaq.length && currentlyActiveFaq[0] !== faq[0]) {
            currentlyActiveFaq.removeClass('active');
            currentlyActiveFaq.find('.faq__body').css('max-height', '0');
        }

        faq.toggleClass('active');
        const body = faq.find('.faq__body');
        if (faq.hasClass('active')) {
            body.css('max-height', body[0].scrollHeight + 'px');
        } else {
            body.css('max-height', '0');
        }
    });
    
});
document.querySelectorAll('#cat-dropdowns > li').forEach(li => {
    const nestedUL = li.querySelector('ul');

    if (nestedUL) {
        li.classList.add('has-dropdown');

        li.addEventListener('click', () => {
            li.classList.toggle('active');
        });
    }
});

document.querySelector('.btn--top')?.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});


// Table of contents


document.addEventListener('DOMContentLoaded', function() {
    const topParents = document.querySelectorAll('.top-parent');
    
    topParents.forEach(parent => {
        parent.addEventListener('click', function(e) {
            if (e.target.tagName === 'A' && !e.target.classList.contains('main-heading')) {
                return;
            }

            const mainHeading = parent.querySelector('.main-heading');
            const tables = parent.querySelector('.tables');
            if (!mainHeading.classList.contains('active')) {
                document.querySelectorAll('.main-heading').forEach(heading => {
                    heading.classList.remove('active');
                });

                // Hide all other tables
                document.querySelectorAll('.tables').forEach(table => {
                    table.classList.add('d-none');
                });

                // Add .active to the clicked main-heading
                mainHeading.classList.add('active');

                // Show the clicked tables
                if (tables) {
                    tables.classList.remove('d-none');
                }
            }

            if (e.target.classList.contains('main-heading')) {
                window.location.href = e.target.getAttribute('href');
            }
        });
    });

    const tableLinks = document.querySelectorAll('.tables li a');
    
    function setActiveTableLink() {
        tableLinks.forEach(link => {
            link.classList.toggle('active', window.location.hash === link.getAttribute('href'));
        });
    }
    
    tableLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            tableLinks.forEach(el => el.classList.remove('active'));
            
            this.classList.add('active');

            const targetId = this.getAttribute('href');
            if (targetId.startsWith('#')) {
                const target = document.querySelector(targetId);
                if (target) {
                    e.preventDefault();
                    window.scrollTo({
                        top: target.offsetTop - 20, // Adjust offset as needed
                        behavior: 'smooth'
                    });
                    // Update URL without page jump
                    history.pushState(null, null, targetId);
                }
            }
        });
    });
    
    setActiveTableLink();
    window.addEventListener('hashchange', setActiveTableLink);
});

